import { Icon } from '../components/Icon';
import { Button, Kbd } from '../components/ui';
import type { TradingEnv } from '../routes/types';
import { useFullscreen } from './fullscreen';
import { EnvBadge } from './live/EnvBadge';

/** The compact bar that survives in full-screen mode: instrument, session, shortcuts, exit. */
export function FullscreenBar({ env, deployment }: { env: TradingEnv; deployment: string }) {
  const { info, exit } = useFullscreen();
  return (
    <div
      data-fullscreen-bar
      className="flex min-w-0 flex-wrap items-center gap-2.5 border-b border-border bg-surface px-3.5 py-2 pt-[max(8px,env(safe-area-inset-top))]"
    >
      <Button size="sm" onClick={exit} data-fullscreen-exit>
        <Icon name="collapse" size={13} />
        Exit full screen <Kbd>Esc</Kbd>
      </Button>
      {info ? (
        <>
          <b className="num text-[13px]">{info.instrument}</b>
          <span className="num text-[12px] text-ink-3">{info.session}</span>
        </>
      ) : null}
      <div className="flex-1" />
      <span className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[11.5px] text-ink-3">
        {info?.shortcuts?.map((s) => (
          <span key={s.key} className="inline-flex items-center gap-1">
            <Kbd>{s.key}</Kbd> {s.label}
          </span>
        ))}
        <span className="inline-flex items-center gap-1">
          <Kbd>F</Kbd> toggle
        </span>
        <span className="inline-flex items-center gap-1">
          <Kbd>Esc</Kbd> exit
        </span>
      </span>
      <EnvBadge env={env} deployment={deployment} compact />
    </div>
  );
}
